"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderingDetail = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 拠点表示順詳細コンポーネント
 */
class OrderingDetail extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "INIT_STATE", {
      subActions: {
        xs: 0,
        sm: 0,
        md: 0
      }
    });
    const {
      returnBtn
    } = this.props;
    this.state = _objectSpread({}, this.INIT_STATE);
    if (returnBtn) {
      this.state.subActions.xs = 3;
      this.state.subActions.sm = 2;
      this.state.subActions.md = 2;
    }
  }
  render() {
    const {
      intl,
      title,
      action,
      returnBtn,
      completed,
      detail
    } = this.props;
    const {
      xs,
      sm,
      md
    } = this.state.subActions;
    let kaishaNm = _stringConsts.STRING_CONSTS.EMPTY; // 会社名
    let areaNm = _stringConsts.STRING_CONSTS.EMPTY; // 地域名
    let siteNmList = []; // 拠点のリスト

    if (detail !== undefined && detail.length > 0) {
      kaishaNm = detail[0].kaishaNm; // 会社名
      areaNm = detail[0].areaNm; // 地域名

      // 拠点のリストを作成する（建物名＋拠点名）
      for (let i in detail) {
        let siteNm = _stringConsts.STRING_CONSTS.EMPTY;
        if (detail[i].buildingNm !== null && detail[i].buildingNm !== _stringConsts.STRING_CONSTS.EMPTY) {
          if (siteNm.length !== 0) {
            siteNm = siteNm + _stringConsts.STRING_CONSTS.HALF_SPACE; // 空白スペースを末尾に追加
          }
          siteNm = siteNm + detail[i].buildingNm; // 建物名を追加
        }
        if (detail[i].siteNm !== null && detail[i].siteNm !== _stringConsts.STRING_CONSTS.EMPTY) {
          if (siteNm.length !== 0) {
            siteNm = siteNm + _stringConsts.STRING_CONSTS.HALF_SPACE; // 空白スペースを末尾に追加
          }
          siteNm = siteNm + detail[i].siteNm; // 拠点名を追加
        }
        siteNmList.push(siteNm); // 連結した文字列をリストに追加
      }
    }
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: title,
      actions: [returnBtn]
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, siteNmList.length === 0 ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_NO_DATA_TO_DISPLAY
    })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, action && completed && /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: action
    }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12 - xs,
        sm: 12 - sm,
        md: 12 - md
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_COMPANY_NAME
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(kaishaNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12,
        sm: sm,
        md: md
      },
      align: 'right'
    }, returnBtn), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12 - xs,
        sm: 12 - sm,
        md: 12 - md
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.MASTERDATA_AREA_NM
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(areaNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_BASE_NAME
      }),
      indent: true
    }, siteNmList.map((siteNm, i) => /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      key: i
    }, _stringUtil.default.emptyToHyphen(siteNm)))))))));
  }
}
exports.OrderingDetail = OrderingDetail;
OrderingDetail.propTypes = {
  detail: _propTypes.default.arrayOf(_propTypes.default.shape({
    kaishaNm: _propTypes.default.string.isRequired,
    siteNm: _propTypes.default.string.isRequired,
    areaNm: _propTypes.default.string.isRequired,
    buildingNm: _propTypes.default.string.isRequired
  })).isRequired,
  completed: _propTypes.default.bool,
  action: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  returnBtn: _propTypes.default.element.isRequired
};
OrderingDetail.defaultProps = {
  completed: true
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(OrderingDetail));